import React from "react";
import { ShieldAlert } from "lucide-react";
import EvaluationQuestionBoolean from "./EvaluationQuestionBoolean";
import EvaluationQuestionChoice from "./EvaluationQuestionChoice";
import EvaluationQuestionRating from "./EvaluationQuestionRating";
import EvaluationQuestionText from "./EvaluationQuestionText";

export default function EvaluationQuestionRenderer({ question, scaleOptions, value, onChange, disabled }) {
    if (!question?.supportedInV1) {
        return (
            <div className="qr-unsupported">
                <ShieldAlert size={18} />
                <div>
                    <strong>Ce type de question n'est pas supporte pour le moment.</strong>
                    <p>{question?.unsupportedMessage || "Le modele d'options sera clarifie dans une version ulterieure."}</p>
                </div>
            </div>
        );
    }

    switch (question.questionType) {
        case "RATING":
            return <EvaluationQuestionRating question={question} scaleOptions={scaleOptions} value={value} onChange={onChange} disabled={disabled} />;
        case "TEXT":
            return <EvaluationQuestionText value={value} onChange={onChange} disabled={disabled} />;
        case "BOOLEAN":
            return <EvaluationQuestionBoolean question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "CHOICE":
            return <EvaluationQuestionChoice question={question} value={value} onChange={onChange} disabled={disabled} />;
        default:
            return null;
    }
}
